import { TableFragment, Sheet, Spreadsheet } from "./excel-model";

/**
 * Функция, которая создаёт отчёт при помощи CreateExcel
 * @param reportContent - листы отчёта
 */
export default function makeXLSX(reportContent) {
  const spreadsheet = new Spreadsheet(reportContent.map(({ sheetName, sheet }) => new Sheet(sheetName, TableFragment.fromJSON(sheet))));
  console.log(spreadsheet);
  spreadsheet.createExcel();
}
